import React, { useEffect, useState } from 'react';
import { useRealtime } from '../contexts/RealtimeContext';
import { getUserRole, ROLES } from '../utils/rbac';

/**
 * Debug component to show current user role and profile data
 * Add this to your app temporarily to debug role issues
 */
const DebugUserRole = () => {
  const { currentUser, userProfile, isInitialized } = useRealtime();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (currentUser && userProfile) {
      const userRole = getUserRole(userProfile, currentUser);
      console.log('🐛 DEBUG - User Role Info:', {
        uid: currentUser.uid,
        email: currentUser.email,
        profileRole: userProfile.role,
        profileUserType: userProfile.userType,
        determinedRole: userRole,
        isAdmin: userProfile.isAdmin,
        timestamp: new Date().toISOString()
      });
    }
  }, [currentUser, userProfile]);

  if (!isVisible || !currentUser) return null;

  const userRole = userProfile ? getUserRole(userProfile, currentUser) : 'loading...';

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        background: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '15px',
        borderRadius: '8px',
        fontSize: '12px',
        zIndex: 9999,
        maxWidth: '300px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <strong>🐛 Debug: User Role</strong>
        <button 
          onClick={() => setIsVisible(false)}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          ×
        </button>
      </div>
      
      <div style={{ fontSize: '11px', lineHeight: '1.6' }}>
        <div><strong>Initialized:</strong> {isInitialized ? '✅' : '⏳'}</div>
        <div><strong>User:</strong> {currentUser?.email || 'None'}</div>
        <div><strong>Profile Loaded:</strong> {userProfile ? '✅' : '❌'}</div>
        {userProfile && (
          <>
            <div><strong>Profile Role:</strong> {userProfile.role || 'NOT SET'}</div>
            <div><strong>Profile UserType:</strong> {userProfile.userType || 'NOT SET'}</div>
            <div><strong>Determined Role:</strong> {userRole}</div>
            <div><strong>Expected Path:</strong> {
              userRole === ROLES.TEACHER ? '/teacher/dashboard' :
              userRole === ROLES.ADMIN ? '/admin' :
              userRole === ROLES.COACHING_ADMIN ? '/coaching-admin' :
              '/dashboard'
            }</div>
          </>
        )}
        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #444' }}>
          <strong>Current Path:</strong> {window.location.pathname}
        </div>
      </div>
    </div>
  );
};

export default DebugUserRole;
